var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0c-.096 0-.193.002-.29.007C4.756.143 2.288 2.46 2.025 5.354c-.185 2.035.685 3.875 2.132 5.06.783.642 1.176 1.563 1.176 2.564v2.355c0 .369.299.667.667.667h4a.666.666 0 0 0 .667-.667v-2.395c0-.98.385-1.882 1.154-2.506A5.83 5.83 0 0 0 14 5.895C14 2.639 11.314 0 8 0zm2 15.333H6v-2h4v2zm1.4-5.418c-.903.733-1.4 1.806-1.4 3.023v-.271H8.333V6.62A1.33 1.33 0 0 0 8 4a1.33 1.33 0 0 0-.333 2.62v6.047H5.984c-.078-1.107-.567-2.082-1.404-2.768a5.189 5.189 0 0 1-1.891-4.485C2.919 2.876 5.139.793 7.74.673 7.828.669 7.914.667 8 .667c2.94 0 5.333 2.345 5.333 5.228a5.165 5.165 0 0 1-1.932 4.02zM8 6a.667.667 0 1 1 .001-1.335A.667.667 0 0 1 8 6z",
  fill: "#fff"
});

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.68307886.svg";
export { ForwardRef as ReactComponent };